import { environmentConfig } from "@src/appV2/environment";

const CHECKR_REPORTS_PATH = "/reports";

const CHECKR_REPORTS_DEFAULT_PARAMS: Record<string, string> = {
  order_by: "created_at",
  page: "1",
  per_page: "25",
  sort: "DESC",
  fields:
    "status:true:true,assessment:true:true,candidate_full_name:true:false,candidate_id:true:false,package_slug:true:false,requestor_email:true:false,created_at:true:false,completed_at:true:false,dispute_status:true:false,adjudication:false:false,tags:false:false",
};

export function getCheckrDashboardUrl(query: string): string {
  const url = new URL(CHECKR_REPORTS_PATH, environmentConfig.REACT_APP_CHECKR_DASHBOARD_URL);
  url.search = new URLSearchParams({ ...CHECKR_REPORTS_DEFAULT_PARAMS, q: query }).toString();
  return url.toString();
}
